import { ChartOptionsProvider, CHART_FLEXED_COLOUR, CHART_INDUSTRY_COLOUR } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class IndexedEbitEstimateOptionsProvider extends ChartOptionsProvider {
  public getOptions(company) {


    const indexedEbitEstimates = company.platformData.indexedEbitEstimates;
    const indexedEbitEstimatesUSD = company.platformData.indexedEbitEstimatesUSD;
    const industryEbitEstimates = company.platformData.industryEbitEstimates.medians;

    const series: any[] = [,
      {
        name: `Company (${company.currency || company.platformData.currencyUnit})`,
        data: indexedEbitEstimates.map(item => [new Date(item.date).getTime(), item.ratio * 100]),
        visible: true
      }
    ]

    if ((company.currency && company.currency !=='USD') || (!company.currency && company.platformData.currencyUnit !== 'USD')) {
      series.push(
        {
          name: 'Company (USD)',
          data: indexedEbitEstimatesUSD.map(item => [new Date(item.date).getTime(), item.ratio * 100]),
          visible: true,
          color: CHART_FLEXED_COLOUR
        }
      )
    }

    series.push(
      {
        name: 'Industry (USD)',
        data: industryEbitEstimates.map(item => [new Date(item.date).getTime(), item.median * 100]),
        visible: true,
        color: CHART_INDUSTRY_COLOUR
      }
    )



    let chartOptions = {
      chart: { spacingBottom: 25 },
      title: 'Indexed Year 2 consensus EBIT estimates',
      legend: {
        y: 20
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          month: '%m/%y'
        },
        tickInterval: 3600 * 24 * 30 * 1000,//time in milliseconds
        minRange: 3600 * 24 * 30 * 1000,
        ordinal: false //this sets the fixed time formats
      },
      yAxis: {
        labels: {
          x: 0
        },
        allowDecimals: true,
        min: Math.min(98.5, Math.min(...indexedEbitEstimates.map(item => item.ratio * 100)) - 2),
        max: Math.max(100.5, Math.max(...indexedEbitEstimates.map(item => item.ratio * 100)) + 2),
        minTickInterval: 1,
        title: {
          text: null
        }
      },
      tooltip: this.defaultChartOptions.tooltip,
      plotOptions: {
        series: {
          marker: {
            enabled: false
          }
        }
      },
      series
    }
    chartOptions = this.setYMax(chartOptions, 100.5);
    chartOptions = this.setYMin(chartOptions, 98.5);
    return super.getOptions(company, chartOptions);
  };
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/indexed-ebit-estimate.ts